export default "__VITE_ASSET__ae1d4679__"